/* eslint-disable */
import domains from '../../domains.js';

//Todo 四个URL各自的作用是什么？
const livenessApi = '/liveness/check_liveness';
const silentLivenessApi = '/liveness/check_silent_liveness';
const livenessShot = '/liveness/liveness_image';
const livenessHackApi = '/hackness/selfie_hack_detect';
// 人脸识别 http://devdoc.cloud.linkface.cn/identity/identity_selfie_idnumber_verification.html
const livenessIdentity = '/identity/selfie_idnumber_verification'

function getPublicCloud(debug) {
  return debug ? domains.stg.cloud : domains.prod.cloud;
}

/**
 * 该对象存在两个属性：
 * host：访问的主机名。
 * auth：授权信息。
 */
export default class Config {
  /**
   * @param options 选项对象，可能存在的属性有：
   * host：主机名或者ip地址
   * apiId、apiSecret：访问公有云时，用于授权。
   */
  constructor(options) {
    //Todo 猜测：进入if的话，说明是提供了代理服务器
    if (options.host) {
      this.host = options.host;
      this.auth = '';
    } else if (options.apiId && options.apiSecret) { //Todo 猜测：进入else的话，说明，直接访问公用云。
      this.host = getPublicCloud(options.debug);
      this.auth = `?api_id=${options.apiId}&api_secret=${options.apiSecret}`;
    } else {
      throw new Error('Please provide api server or api authenciation');
    }
  }

  livenessApi() {
    return `${this.host}${livenessApi}${this.auth}`;
  }

  silentLivenessApi() {
    return `${this.host}${silentLivenessApi}${this.auth}`;
  }

  livenessShot(uuid) {
    return `${this.host}${livenessShot}/${uuid}${this.auth}`;
  }

  livenessHackApi() {
    return `${this.host}${livenessHackApi}${this.auth}`;
  }

  livenessIdentity() {
    return `${this.host}${livenessIdentity}${this.auth}`;
  }
};
